export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10966.0aa49f6e.jpg";